import { Modal, Popover } from 'antd';
import moment from 'moment';
import { Details } from '../../../../api/getLabTestSlot';
import { Data, Test } from '../../../../api/getLabTestsOrder';
import {
    Address,
    Clinic,
    LabTestsEntityOrProceduresEntity,
    Prescription,
} from '../../../../store/types/prescription';
import { Div, paymodeObj } from './OrderMedicineUtils';
import { LabOption } from '../../../../api/createLabTestCart';
import { Fragment } from 'react';
import { track } from '../../../../tracking';
import { ShepherdOptionsWithType } from 'react-shepherd';
import { PopperPlacement } from '../../../../pages/trialOrder/Utils';
import { AntTooltip } from '../../../common/AntTooltip';
import { getDoc, getSelectedClinicId } from '../../../../store/idbHandler';
import { LabTest } from '../../../../api/fetchMatchingDrugsLabTests';
import { isOnboardedForLab } from '../../../../pages/utils';
import {
    generatePrescriptionId,
    generateVisitId,
    getAgeInMonths,
    getAgeInYears,
} from '../../../../store/utils';
import { AdditionalMemberWithPersonal } from './BookLabTests';
import { focusCard } from '../workspace/focusCard';
import { Patient } from '../../../../store/types/patient';
import { captureError } from '../../../../pages/captureError';
import { Order } from '../../../../api/fetchAllHEOrder';
import { UpdateStatuses } from '../../../../api/orderLabTestCart';

export interface AddressFormInput {
    _id?: string;
    line: string;
    landmark: string;
    city: string;
    state: string;
    city_id: string;
    place_id: string;
    coordinates: string;
    pincode: string;
}

export interface SelectedSlotDetails {
    collection_date: string;
    collection_slot: {
        id: number;
        details: Details;
    };
}

export const orderStatusObj: {
    [k: string]: {
        text: string;
        textColor: string;
        bgColor: string;
        icon: JSX.Element;
        finish: number[];
    };
} = {
    init: {
        text: 'is confirmed',
        textColor: 'darwin-accent-symptoms-blue-800',
        bgColor: 'darwin-accent-symptoms-blue-100',
        icon: (
            <svg
                className="w-21 h-24 fill-darwin-accent-symptoms-blue-800"
                viewBox="0 0 21 22"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M2.34375 1.76562L0 6.5H9.75V0.5H4.35938C3.51562 0.5 2.71875 1.01562 2.34375 1.76562ZM11.25 6.5H21L18.6094 1.76562C18.2344 1.01562 17.4375 0.5 16.5938 0.5H11.25V6.5ZM21 8H0V18.5C0 20.1875 1.3125 21.5 3 21.5H18C19.6406 21.5 21 20.1875 21 18.5V8Z" />
            </svg>
        ),
        finish: [1],
    },
    rescheduled: {
        text: 'has been rescheduled',
        textColor: 'darwin-accent-examination-findings-sky-blue-900',
        bgColor: 'darwin-accent-examination-findings-sky-blue-100',
        icon: (
            <svg
                className="w-24 h-24 fill-darwin-accent-examination-findings-sky-blue-900"
                viewBox="0 0 28 32"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M9.5 4L18.5 4V1.5C18.5 0.6875 19.125 0 20 0C20.8125 0 21.5 0.6875 21.5 1.5V4H24C26.1875 4 28 5.8125 28 8L28 28C28 30.25 26.1875 32 24 32L4 32C1.75 32 0 30.25 0 28L0 8C0 5.8125 1.75 4 4 4H6.5L6.5 1.5C6.5 0.6875 7.125 0 8 0C8.8125 0 9.5 0.6875 9.5 1.5V4ZM3 28C3 28.5625 3.4375 29 4 29L24 29C24.5 29 25 28.5625 25 28V12L3 12L3 28Z"></path>
            </svg>
        ),
        finish: [1],
    },
    cancelled: {
        text: 'has been cancelled',
        textColor: 'darwin-status-warning-500',
        bgColor: 'darwin-status-warning-100',
        icon: (
            <svg
                className="w-24 h-24 fill-darwin-status-warning-500"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M12 24C5.34375 24 0 18.6562 0 12C0 5.39062 5.34375 0 12 0C18.6094 0 24 5.39062 24 12C24 18.6562 18.6094 24 12 24ZM8.20312 8.20312C7.73438 8.67188 7.73438 9.375 8.20312 9.79688L10.4062 12L8.20312 14.2031C7.73438 14.6719 7.73438 15.375 8.20312 15.7969C8.625 16.2656 9.32812 16.2656 9.75 15.7969L11.9531 13.5938L14.1562 15.7969C14.625 16.2656 15.3281 16.2656 15.75 15.7969C16.2188 15.375 16.2188 14.6719 15.75 14.2031L13.5469 12L15.75 9.79688C16.2188 9.375 16.2188 8.67188 15.75 8.20312C15.3281 7.78125 14.625 7.78125 14.1562 8.20312L11.9531 10.4062L9.75 8.20312C9.32812 7.78125 8.625 7.78125 8.20312 8.20312Z" />
            </svg>
        ),
        finish: [1],
    },
    phleboassigned: {
        text: '- Sample collection in progress',
        textColor: 'darwin-accent-bright-yellow-900',
        bgColor: 'darwin-accent-bright-yellow-200',
        icon: (
            <svg
                className="w-24 h-24 fill-darwin-accent-bright-yellow-900"
                viewBox="0 0 25 25"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M16.0312 1.46875L17.5312 2.96875L22.0312 7.46875L23.5312 8.96875C24.1406 9.53125 24.1406 10.5156 23.5312 11.0781C22.9688 11.6875 21.9844 11.6875 21.4219 11.0781L21 10.6562L7.92188 23.6875C7.07812 24.5312 5.95312 25 4.73438 25H4.5C2.01562 25 0 22.9844 0 20.5V20.2656C0 19.0469 0.46875 17.9219 1.3125 17.0781L14.3438 4.04688L13.9219 3.57812C13.3125 3.01562 13.3125 2.03125 13.9219 1.46875C14.4844 0.859375 15.4688 0.859375 16.0312 1.46875ZM9.60938 13H14.3438L18.8438 8.5L16.5 6.15625L9.60938 13Z" />
            </svg>
        ),
        finish: [1, 1],
    },
    pickup: {
        text: '- Preparing medical report',
        textColor: 'darwin-accent-diagnosis-purple-800',
        bgColor: 'darwin-accent-diagnosis-purple-100',
        icon: (
            <svg
                className="w-18 h-24 fill-darwin-accent-diagnosis-purple-800"
                viewBox="0 0 18 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M3 0H10.5V6C10.5 6.84375 11.1562 7.5 12 7.5H18V21C18 22.6875 16.6406 24 15 24H3C1.3125 24 0 22.6875 0 21V3C0 1.35938 1.3125 0 3 0ZM12 0L18 6H12V0ZM7.5 11.25V13.5H5.25C4.82812 13.5 4.5 13.875 4.5 14.25V15.75C4.5 16.1719 4.82812 16.5 5.25 16.5H7.5V18.75C7.5 19.1719 7.82812 19.5 8.25 19.5H9.75C10.125 19.5 10.5 19.1719 10.5 18.75V16.5H12.75C13.125 16.5 13.5 16.1719 13.5 15.75V14.25C13.5 13.875 13.125 13.5 12.75 13.5H10.5V11.25C10.5 10.875 10.125 10.5 9.75 10.5H8.25C7.82812 10.5 7.5 10.875 7.5 11.25Z" />
            </svg>
        ),
        finish: [1, 1, 1],
    },
    partially_delivered: {
        text: '- Medical report partially sent',
        textColor: 'darwin-accent-green-800',
        bgColor: 'darwin-accent-green-100',
        icon: (
            <svg
                className="w-24 h-24 fill-darwin-accent-green-800"
                viewBox="0 0 16 17"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2 2.5C2 1.40625 2.875 0.5 4 0.5H9V4.5C9 5.0625 9.4375 5.5 10 5.5H14V14.5C14 15.625 13.0938 16.5 12 16.5H4C2.875 16.5 2 15.625 2 14.5V2.5ZM14 4.5H10V0.5L14 4.5Z"
                    fill="#D1EDE1"
                />
                <mask
                    id="mask0_6602_14766"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="0"
                    width="12"
                    height="17"
                >
                    <path
                        d="M2 2.5C2 1.40625 2.875 0.5 4 0.5H9V4.5C9 5.0625 9.4375 5.5 10 5.5H14V14.5C14 15.625 13.0938 16.5 12 16.5H4C2.875 16.5 2 15.625 2 14.5V2.5ZM14 4.5H10V0.5L14 4.5Z"
                        fill="#004BA8"
                    />
                </mask>
                <g mask="url(#mask0_6602_14766)">
                    <rect y="8.5" width="16" height="8" fill="#19A66A" />
                </g>
            </svg>
        ),
        finish: [1, 1, 1, 1],
    },
    delivered: {
        text: '- Complete Medical report delivered successfully',
        textColor: 'darwin-accent-green-800',
        bgColor: 'darwin-accent-green-100',
        icon: (
            <svg
                className="w-24 h-24 fill-darwin-accent-green-800"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M12 0C13.6875 0 15.1875 0.984375 15.9375 2.4375C17.4844 1.92188 19.2656 2.29688 20.4844 3.51562C21.7031 4.73438 22.0781 6.51562 21.5625 8.0625C23.0156 8.8125 24 10.3125 24 12C24 13.7344 23.0156 15.2344 21.5625 15.9844C22.0781 17.5312 21.7031 19.2656 20.4844 20.4844C19.2656 21.7031 17.4844 22.0781 15.9375 21.6094C15.1875 23.0625 13.6875 24 12 24C10.2656 24 8.76562 23.0625 8.01562 21.6094C6.46875 22.0781 4.73438 21.7031 3.51562 20.4844C2.29688 19.2656 1.92188 17.5312 2.39062 15.9844C0.9375 15.2344 0 13.7344 0 12C0 10.3125 0.9375 8.8125 2.39062 8.0625C1.92188 6.51562 2.29688 4.73438 3.51562 3.51562C4.73438 2.29688 6.46875 1.92188 8.01562 2.4375C8.76562 0.984375 10.2656 0 12 0ZM16.5469 10.5469C16.9688 10.125 16.9688 9.42188 16.5469 9C16.0781 8.53125 15.375 8.53125 14.9531 9L10.5 13.4531L8.67188 11.625C8.20312 11.1562 7.5 11.1562 7.07812 11.625C6.60938 12.0469 6.60938 12.75 7.07812 13.1719L9.70312 15.7969C10.125 16.2656 10.8281 16.2656 11.2969 15.7969L16.5469 10.5469Z" />
            </svg>
        ),
        finish: [1, 1, 1, 1, 1],
    },
};

export const OrderDetailsComponent: React.FC<{
    finishedState: Data;
    isForTrialOrder?: boolean;
}> = ({ finishedState, isForTrialOrder }) => {
    const subStatus = [
        'init',
        'delivered',
        'pickup',
        'phleboassigned',
        'cancelled',
        'rescheduled',
        'partially_delivered',
    ];
    const {
        status,
        sub_status,
        tat_time_str,
        members = [],
        vendorOrderId,
        extra_charges,
        amount,
        paidAmount,
        platformdiscount,
    } = finishedState;
    const { start_time, end_time } = finishedState.collection_slot.details;
    const { text, textColor, bgColor, icon, finish } = orderStatusObj[
        subStatus.includes(sub_status) ? sub_status : status
    ];
    const showAdditionalMembers = Array.isArray(members) && members?.length > 1;
    const totalExtraCharges = Number(extra_charges?.total || 0);
    const totalMRP = finishedState.amount - totalExtraCharges;
    const totalAmount = finishedState.paidAmount;
    const absoluteDiscount = amount - paidAmount;
    const discountedPrice = totalMRP - absoluteDiscount;

    return (
        <div className="p-16 h-full flex-1 overflow-scroll mt-2 space-y-16 pb-100">
            <div
                className={`p-16 space-y-14 font-400 text-13 bg-${bgColor} border border-${textColor} rounded-8`}
                id="track-timeline"
            >
                <div className="flex items-center space-x-16">
                    {icon}
                    <p className={`text-18 font-700 text-${textColor}`}>
                        Order #{finishedState.id} {text}!
                    </p>
                </div>

                <div className="bg-white rounded-8 p-16 space-y-20">
                    <Div
                        finish={finish[0]}
                        text={`Order confirmed at ${moment(finishedState.created_at).format(
                            'MMMM Do YYYY, h:mm:ss a',
                        )}`}
                    />
                    <Div finish={finish[1]} text="Collection Partner Assigned" />
                    <Div finish={finish[2]} text="Sample Collected" />
                    <Div finish={finish[3]} text={'Medical Report Partially Sent'} />
                    <Div finish={finish[4]} text={'Medical Report Delivered'} />
                    {tat_time_str && <p className="text-13 font-600">{tat_time_str}</p>}
                </div>
            </div>

            <div className="grid grid-cols-3 space-x-16">
                <div className="bg-white border border-darwin-neutral-200 rounded-8 col-span-2">
                    <div className="px-16 py-8 flex items-center justify-between border-b border-darwin-neutral-100">
                        <p className="text-14 font-700">
                            Lab Tests Booked ({finishedState.cart.length})
                        </p>
                        {vendorOrderId ? (
                            <p className="text-14 font-700">Vendor booking id : {vendorOrderId}</p>
                        ) : (
                            <p className="text-13 text-darwin-neutral-800">
                                Options are based on prescribed lab tests
                            </p>
                        )}
                    </div>
                    <div className="px-16 py-12 space-y-8">
                        {finishedState.cart.map((test, index) => (
                            <p className="space-x-5">
                                <span>{index + 1}.</span>
                                <span>{test.name}</span>
                                <span>:</span>
                                <span
                                    className={`relative font-400 ${
                                        test.tests?.length ? 'pr-22' : ''
                                    } whitespace-nowrap`}
                                >
                                    ₹ {test.price}
                                    <LabTestsIncludedInPackage tests={test.tests} />
                                </span>
                                <TestingType
                                    i={
                                        {
                                            testing_type: test.testing_type,
                                        } as LabTest
                                    }
                                    className="px-6 py-3 relative -top-1 text-11"
                                />
                            </p>
                        ))}
                        <div className="flex items-center space-x-10 pt-4">
                            <p className="font-700">Provided by:</p>
                            <img
                                src={`/images/${finishedState.vendorid?.toLowerCase()}.png`}
                                alt={finishedState.vendorname}
                                className="h-26"
                            />
                        </div>
                    </div>
                </div>

                <div className="bg-white border border-darwin-neutral-200 rounded-8 col-span-1">
                    <p className="px-16 py-8 border-b border-darwin-neutral-100 font-700">
                        Sample Collection Details
                    </p>
                    <div className="px-16 py-12 space-y-8">
                        <p>
                            <span className="font-700">Collection Date: </span>
                            <span>
                                {moment(finishedState.collection_date).format('DD MMMM YYYY')}
                            </span>
                        </p>
                        {start_time && end_time && (
                            <p>
                                <span className="font-700">Collection Time: </span>
                                {finishedState.inclinic_sample_collection ? (
                                    <span>In-clinic Collection</span>
                                ) : (
                                    <span>
                                        {getTimeIn12HourFormat(start_time)} -{' '}
                                        {getTimeIn12HourFormat(end_time)}
                                    </span>
                                )}
                            </p>
                        )}
                    </div>
                </div>
            </div>

            <div
                className={`grid ${showAdditionalMembers ? 'grid-cols-3' : 'grid-cols-2'} gap-x-16`}
            >
                <div className="bg-white rounded-8 border border-darwin-neutral-200">
                    <p className="border-b border-darwin-neutral-100 px-16 py-8 font-700">
                        Patient Address
                    </p>
                    <div className="p-16 space-y-8 text-14">
                        <p className="font-700">{finishedState.customerDetails.name}</p>
                        <p className="flex flex-wrap gap-x-8">
                            <p>+91 {finishedState.customerDetails.mobile}</p>
                            {finishedState.customerDetails.alternative_mobile?.trim().length !==
                                0 && (
                                <p>(Alt: +91 {finishedState.customerDetails.alternative_mobile})</p>
                            )}
                        </p>
                        <p>
                            {[
                                finishedState.address.line,
                                finishedState.address.landmark,
                                finishedState.address.city,
                                finishedState.address.state,
                                finishedState.address.pincode,
                            ]
                                .filter(Boolean)
                                .join(', ')}
                            .
                        </p>
                    </div>
                </div>
                {showAdditionalMembers && (
                    <div className="bg-white border border-darwin-neutral-200 rounded-8 col-span-1">
                        <p className="px-16 py-8 border-b border-darwin-neutral-100 font-700">
                            Customer Details
                        </p>
                        <div className="px-16 py-12 space-y-8">
                            {members.map(({ name, mobile }, index) => (
                                <div className="flex items-start space-x-8">
                                    <p>{index + 1}.</p>
                                    <p>
                                        {name} (+91 {mobile})
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="bg-white rounded-8 border border-darwin-neutral-200">
                    <p className="border-b border-darwin-neutral-100 px-16 py-8 font-700">
                        Amount Paid
                    </p>
                    <div className="p-16 space-y-8 text-14">
                        <div className="flex items-center justify-between">
                            <p>Total MRP</p>
                            <p>₹ {totalMRP.toFixed(2)}</p>
                        </div>
                        {platformdiscount > 0 && (
                            <div className="flex items-center justify-between">
                                <p>Absolute Discount</p>
                                <p className="text-darwin-accent-green-900">
                                    - ₹ {absoluteDiscount.toFixed(2)}
                                </p>
                            </div>
                        )}
                        {platformdiscount > 0 && (
                            <div className="flex items-center justify-between">
                                <p>Discounted Price</p>
                                <p>₹ {discountedPrice.toFixed(2)}</p>
                            </div>
                        )}
                        {extra_charges?.details?.map((i) => (
                            <div className="flex items-center justify-between">
                                <p className="capitalize">{i.type?.replaceAll?.('_', ' ')}</p>
                                <p>₹ {i.amount.toFixed(2)}</p>
                            </div>
                        ))}
                        <div className="bg-darwin-neutral-50 rounded-6 p-8 space-y-8">
                            <div className="flex items-center justify-between font-700">
                                <p>Total Amount</p>
                                <p>₹ {totalAmount.toFixed(2)}</p>
                            </div>
                            {platformdiscount > 0 && (
                                <div className="flex items-center justify-between">
                                    <p>Discount</p>
                                    <p className="text-darwin-accent-green-900">
                                        - {platformdiscount.toFixed(2)}%
                                    </p>
                                </div>
                            )}
                            <div className="flex items-center justify-between">
                                <p>Payment mode</p>
                                <p>
                                    {isForTrialOrder
                                        ? 'Free'
                                        : paymodeObj[finishedState.paymode || '-']}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const FetchingLoader: React.FC<{ text: string }> = ({ text }) => (
    <div className="flex-1 flex flex-col items-center justify-center space-y-72">
        <div className="pulse">
            <svg width="16px" height="12px">
                <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
            </svg>
        </div>
        <p className="text-24 text-neutral-black ml-12">Fetching {text}</p>
    </div>
);

export const CloseBtIcon: React.FC<{ closeMe: () => void }> = ({ closeMe }) => (
    <svg
        className="w-12 h-12 fill-darwin-neutral-1000 cursor-pointer"
        viewBox="0 0 12 12"
        xmlns="http://www.w3.org/2000/svg"
        onClick={closeMe}
    >
        <path d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z" />
    </svg>
);

export const showDateInText = (date: string): string => {
    if (moment().format('YYYY-MM-DD') === date) return 'Today';
    if (moment().add(1, 'days').format('YYYY-MM-DD') === date) return 'Tomorrow';
    return moment(date).format('LL');
};

export const HomeCollectionFees: React.FC<{ i: LabOption; collectionType: string }> = ({
    i,
    collectionType,
}) => {
    const isInclinicCollection = collectionType === INCLINIC_COLLECTION;
    if (isInclinicCollection && inClinicSampleCollectionEnabled.has(i.vendor_id)) return null;
    return (
        <Fragment>
            {Object.entries(i.extra_charges)?.map((i) => (
                <p className="pt-2 space-x-5">
                    <span className="capitalize">{i[0]?.replaceAll?.('_', ' ')}</span>
                    <span>:</span>
                    <span>₹ {i[1]?.toFixed(2)}</span>
                </p>
            ))}
        </Fragment>
    );
};

export const UnavailableLabTests: React.FC<{
    unavailableLabTests?: LabTestsEntityOrProceduresEntity[];
}> = ({ unavailableLabTests }) => {
    return unavailableLabTests?.length ? (
        <div className="text-13 py-2">
            <span className="text-darwin-status-warning-500 font-700 whitespace-nowrap pr-8">
                Unavailable Lab Tests:
            </span>
            <span className="text-darwin-neutral-800">
                {unavailableLabTests.map((i) => i.name).join(' | ')}
            </span>
        </div>
    ) : null;
};

export const LabTestsIncludedInPackage: React.FC<{
    tests?: Test[];
}> = ({ tests }) => {
    return tests && tests.length ? (
        <Popover
            placement="right"
            title={
                <p className="font-700 select-none">
                    Tests included in this package ({tests.length})
                </p>
            }
            content={
                <div className="space-y-4 select-none overflow-auto max-h-328">
                    {tests.map((test, index) => (
                        <p className="flex items-start space-x-8">
                            <p>{index + 1}.</p>
                            <p>{test.name}</p>
                        </p>
                    ))}
                </div>
            }
            trigger="hover"
        >
            <div className="absolute top-0 right-0">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-16 h-16 fill-darwin-primary-500"
                    viewBox="0 0 12 13"
                >
                    <path d="M6 0.5C2.67188 0.5 0 3.19531 0 6.5C0 9.82812 2.67188 12.5 6 12.5C9.30469 12.5 12 9.82812 12 6.5C12 3.19531 9.30469 0.5 6 0.5ZM6 11.375C3.30469 11.375 1.125 9.19531 1.125 6.5C1.125 3.82812 3.30469 1.625 6 1.625C8.67188 1.625 10.875 3.82812 10.875 6.5C10.875 9.19531 8.67188 11.375 6 11.375ZM6.9375 8.375H6.5625V6.3125C6.5625 6.00781 6.30469 5.75 6 5.75H5.25C4.92188 5.75 4.6875 6.00781 4.6875 6.3125C4.6875 6.64062 4.92188 6.875 5.25 6.875H5.4375V8.375H5.0625C4.73438 8.375 4.5 8.63281 4.5 8.9375C4.5 9.26562 4.73438 9.5 5.0625 9.5H6.9375C7.24219 9.5 7.5 9.26562 7.5 8.9375C7.5 8.63281 7.24219 8.375 6.9375 8.375ZM6 5C6.39844 5 6.75 4.67188 6.75 4.25C6.75 3.85156 6.39844 3.5 6 3.5C5.57812 3.5 5.25 3.85156 5.25 4.25C5.25 4.67188 5.57812 5 6 5Z" />
                </svg>
            </div>
        </Popover>
    ) : null;
};

export const getTimeIn12HourFormat = (time: string): string => {
    const random = moment().format('YYYY-MM-DD');
    const result = moment(`${random} ${time}`).format('h:mm a').toUpperCase();
    return result;
};

export const GetLabOrderStatus: React.FC<{
    order_details: Data | Order;
    removeBorder?: boolean;
    showTag?: boolean;
}> = ({ order_details, removeBorder, showTag }) => {
    if (!order_details) {
        return <p className="text-darwin-neutral-900">Not Ordered</p>;
    }
    const { status, sub_status, delivered_early_by } = order_details;

    if (status === 'init') {
        if (sub_status === 'pickup') {
            return (
                <div
                    className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-3 text-${orderStatusObj['pickup'].textColor} bg-${orderStatusObj['pickup'].bgColor} rounded-4`}
                >
                    <svg
                        className={`w-13 h-13 fill-${orderStatusObj['pickup'].textColor}`}
                        viewBox="0 0 18 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M3 0H10.5V6C10.5 6.84375 11.1562 7.5 12 7.5H18V21C18 22.6875 16.6406 24 15 24H3C1.3125 24 0 22.6875 0 21V3C0 1.35938 1.3125 0 3 0ZM12 0L18 6H12V0ZM7.5 11.25V13.5H5.25C4.82812 13.5 4.5 13.875 4.5 14.25V15.75C4.5 16.1719 4.82812 16.5 5.25 16.5H7.5V18.75C7.5 19.1719 7.82812 19.5 8.25 19.5H9.75C10.125 19.5 10.5 19.1719 10.5 18.75V16.5H12.75C13.125 16.5 13.5 16.1719 13.5 15.75V14.25C13.5 13.875 13.125 13.5 12.75 13.5H10.5V11.25C10.5 10.875 10.125 10.5 9.75 10.5H8.25C7.82812 10.5 7.5 10.875 7.5 11.25Z" />
                    </svg>
                    <p>Sample Collected</p>
                </div>
            );
        }
        if (sub_status === 'phleboassigned') {
            return (
                <div
                    className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-3 text-${orderStatusObj['phleboassigned'].textColor} bg-${orderStatusObj['phleboassigned'].bgColor} rounded-4`}
                >
                    <svg
                        className={`w-13 h-13 fill-${orderStatusObj['phleboassigned'].textColor}`}
                        viewBox="0 0 25 25"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M16.0312 1.46875L17.5312 2.96875L22.0312 7.46875L23.5312 8.96875C24.1406 9.53125 24.1406 10.5156 23.5312 11.0781C22.9688 11.6875 21.9844 11.6875 21.4219 11.0781L21 10.6562L7.92188 23.6875C7.07812 24.5312 5.95312 25 4.73438 25H4.5C2.01562 25 0 22.9844 0 20.5V20.2656C0 19.0469 0.46875 17.9219 1.3125 17.0781L14.3438 4.04688L13.9219 3.57812C13.3125 3.01562 13.3125 2.03125 13.9219 1.46875C14.4844 0.859375 15.4688 0.859375 16.0312 1.46875ZM9.60938 13H14.3438L18.8438 8.5L16.5 6.15625L9.60938 13Z" />
                    </svg>
                    <p>Picked Up</p>
                </div>
            );
        }
        if (sub_status === 'rescheduled') {
            return (
                <div
                    className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-3 text-${orderStatusObj['rescheduled'].textColor} bg-${orderStatusObj['rescheduled'].bgColor} rounded-4`}
                >
                    <svg
                        className={`w-13 h-13 fill-${orderStatusObj['rescheduled'].textColor}`}
                        viewBox="0 0 28 32"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M9.5 4L18.5 4V1.5C18.5 0.6875 19.125 0 20 0C20.8125 0 21.5 0.6875 21.5 1.5V4H24C26.1875 4 28 5.8125 28 8L28 28C28 30.25 26.1875 32 24 32L4 32C1.75 32 0 30.25 0 28L0 8C0 5.8125 1.75 4 4 4H6.5L6.5 1.5C6.5 0.6875 7.125 0 8 0C8.8125 0 9.5 0.6875 9.5 1.5V4ZM3 28C3 28.5625 3.4375 29 4 29L24 29C24.5 29 25 28.5625 25 28V12L3 12L3 28Z"></path>
                    </svg>
                    <p>Rescheduled</p>
                </div>
            );
        }
        return (
            <div
                className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-3 text-${orderStatusObj['init'].textColor} bg-${orderStatusObj['init'].bgColor} rounded-4`}
            >
                <svg
                    className={`w-13 h-13 fill-${orderStatusObj['init'].textColor}`}
                    viewBox="0 0 21 22"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M2.34375 1.76562L0 6.5H9.75V0.5H4.35938C3.51562 0.5 2.71875 1.01562 2.34375 1.76562ZM11.25 6.5H21L18.6094 1.76562C18.2344 1.01562 17.4375 0.5 16.5938 0.5H11.25V6.5ZM21 8H0V18.5C0 20.1875 1.3125 21.5 3 21.5H18C19.6406 21.5 21 20.1875 21 18.5V8Z" />
                </svg>
                <p>Order Placed</p>
            </div>
        );
    }

    if (status === 'cancelled') {
        return (
            <div
                className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-3 text-${orderStatusObj['cancelled'].textColor} bg-${orderStatusObj['cancelled'].bgColor} rounded-4`}
            >
                <svg
                    className={`w-13 h-13 fill-${orderStatusObj['cancelled'].textColor}`}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M12 24C5.34375 24 0 18.6562 0 12C0 5.39062 5.34375 0 12 0C18.6094 0 24 5.39062 24 12C24 18.6562 18.6094 24 12 24ZM8.20312 8.20312C7.73438 8.67188 7.73438 9.375 8.20312 9.79688L10.4062 12L8.20312 14.2031C7.73438 14.6719 7.73438 15.375 8.20312 15.7969C8.625 16.2656 9.32812 16.2656 9.75 15.7969L11.9531 13.5938L14.1562 15.7969C14.625 16.2656 15.3281 16.2656 15.75 15.7969C16.2188 15.375 16.2188 14.6719 15.75 14.2031L13.5469 12L15.75 9.79688C16.2188 9.375 16.2188 8.67188 15.75 8.20312C15.3281 7.78125 14.625 7.78125 14.1562 8.20312L11.9531 10.4062L9.75 8.20312C9.32812 7.78125 8.625 7.78125 8.20312 8.20312Z" />
                </svg>
                <p>Cancelled</p>
            </div>
        );
    }
    return sub_status === 'partially_delivered' ? (
        <div
            className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-3 text-${
                orderStatusObj['partially_delivered'].textColor
            } ${!removeBorder ? 'border' : ''} border-${
                orderStatusObj['partially_delivered'].textColor
            } ${
                removeBorder ? `bg-${orderStatusObj['partially_delivered'].bgColor}` : ''
            } rounded-4`}
        >
            <svg
                className={`w-16 h-16 fill-${orderStatusObj['partially_delivered'].textColor}`}
                viewBox="0 0 16 17"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M2 2.5C2 1.40625 2.875 0.5 4 0.5H9V4.5C9 5.0625 9.4375 5.5 10 5.5H14V14.5C14 15.625 13.0938 16.5 12 16.5H4C2.875 16.5 2 15.625 2 14.5V2.5ZM14 4.5H10V0.5L14 4.5Z"
                    fill="#D1EDE1"
                />
                <mask
                    id="mask0_6602_14766"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="2"
                    y="0"
                    width="12"
                    height="17"
                >
                    <path
                        d="M2 2.5C2 1.40625 2.875 0.5 4 0.5H9V4.5C9 5.0625 9.4375 5.5 10 5.5H14V14.5C14 15.625 13.0938 16.5 12 16.5H4C2.875 16.5 2 15.625 2 14.5V2.5ZM14 4.5H10V0.5L14 4.5Z"
                        fill="#004BA8"
                    />
                </mask>
                <g mask="url(#mask0_6602_14766)">
                    <rect y="8.5" width="16" height="8" fill="#19A66A" />
                </g>
            </svg>
            <p>Partially Sent</p>
        </div>
    ) : delivered_early_by && !showTag ? (
        <div
            className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-4 bg-darwin-neutral-1000 rounded-4`}
            style={{
                color: '#1A1A1A',
                background:
                    'var(--Gradient-green, linear-gradient(100deg, #95E9C1 2.51%, #D8FF71 134.8%))',
            }}
        >
            <svg className="w-13 h-13" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.68555 1.8418L6.03125 5.70898H8.4375C8.7168 5.70898 8.97461 5.88086 9.08203 6.13867C9.16797 6.41797 9.10352 6.71875 8.88867 6.91211L3.38867 11.7246C3.13086 11.918 2.78711 11.9395 2.5293 11.7461C2.27148 11.5742 2.16406 11.2305 2.29297 10.9297L3.94727 7.0625H1.5625C1.26172 7.0625 1.00391 6.89062 0.917969 6.63281C0.810547 6.35352 0.875 6.05273 1.08984 5.85938L6.58984 1.04688C6.84766 0.853516 7.19141 0.832031 7.44922 1.02539C7.70703 1.19727 7.81445 1.54102 7.68555 1.8418Z"
                    fill="#1A1A1A"
                />
            </svg>
            <p>{order_details.delivered_early_by}</p>
        </div>
    ) : (
        <Fragment>
            <div
                className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-3 text-${
                    orderStatusObj['delivered'].textColor
                } ${!removeBorder ? 'border' : ''} border-${
                    orderStatusObj['delivered'].textColor
                } bg-${orderStatusObj['delivered'].bgColor} rounded-4`}
            >
                <svg
                    className={`w-13 h-13 fill-${orderStatusObj['delivered'].textColor}`}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M12 0C13.6875 0 15.1875 0.984375 15.9375 2.4375C17.4844 1.92188 19.2656 2.29688 20.4844 3.51562C21.7031 4.73438 22.0781 6.51562 21.5625 8.0625C23.0156 8.8125 24 10.3125 24 12C24 13.7344 23.0156 15.2344 21.5625 15.9844C22.0781 17.5312 21.7031 19.2656 20.4844 20.4844C19.2656 21.7031 17.4844 22.0781 15.9375 21.6094C15.1875 23.0625 13.6875 24 12 24C10.2656 24 8.76562 23.0625 8.01562 21.6094C6.46875 22.0781 4.73438 21.7031 3.51562 20.4844C2.29688 19.2656 1.92188 17.5312 2.39062 15.9844C0.9375 15.2344 0 13.7344 0 12C0 10.3125 0.9375 8.8125 2.39062 8.0625C1.92188 6.51562 2.29688 4.73438 3.51562 3.51562C4.73438 2.29688 6.46875 1.92188 8.01562 2.4375C8.76562 0.984375 10.2656 0 12 0ZM16.5469 10.5469C16.9688 10.125 16.9688 9.42188 16.5469 9C16.0781 8.53125 15.375 8.53125 14.9531 9L10.5 13.4531L8.67188 11.625C8.20312 11.1562 7.5 11.1562 7.07812 11.625C6.60938 12.0469 6.60938 12.75 7.07812 13.1719L9.70312 15.7969C10.125 16.2656 10.8281 16.2656 11.2969 15.7969L16.5469 10.5469Z" />
                </svg>
                <p>Delivered</p>
            </div>
            {delivered_early_by && showTag && (
                <div
                    className={`text-13 font-700 w-max flex items-center space-x-8 px-10 py-4 bg-darwin-neutral-1000 rounded-4`}
                    style={{
                        color: '#1A1A1A',
                        background:
                            'var(--Gradient-green, linear-gradient(100deg, #95E9C1 2.51%, #D8FF71 134.8%))',
                    }}
                >
                    <svg
                        className="w-13 h-13"
                        viewBox="0 0 10 12"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.68555 1.8418L6.03125 5.70898H8.4375C8.7168 5.70898 8.97461 5.88086 9.08203 6.13867C9.16797 6.41797 9.10352 6.71875 8.88867 6.91211L3.38867 11.7246C3.13086 11.918 2.78711 11.9395 2.5293 11.7461C2.27148 11.5742 2.16406 11.2305 2.29297 10.9297L3.94727 7.0625H1.5625C1.26172 7.0625 1.00391 6.89062 0.917969 6.63281C0.810547 6.35352 0.875 6.05273 1.08984 5.85938L6.58984 1.04688C6.84766 0.853516 7.19141 0.832031 7.44922 1.02539C7.70703 1.19727 7.81445 1.54102 7.68555 1.8418Z"
                            fill="#1A1A1A"
                        />
                    </svg>
                    <p>{order_details.delivered_early_by}</p>
                </div>
            )}
        </Fragment>
    );
};

export const ERR_NON_SERVICEABLE = 'err_non_serviceable';
export const ERR_NO_MAPPING = 'err_no_mapping';

export const createCartErrorObj: { [k: string]: string } = {
    err_non_serviceable: 'Pincode Unserviceable. Try Different Address',
    err_no_mapping: 'None of the Lab Tests Prescribed or Selected are available',
};

export function getSteps(changeSteps?: (activeStep: number) => void): ShepherdOptionsWithType[] {
    const steps = [
        {
            id: 'review-cart',
            attachTo: { element: '#options-available', on: 'right' as PopperPlacement },
            beforeShowPromise: function () {
                return new Promise<void>(function (resolve) {
                    setTimeout(function () {
                        window.scrollTo(0, 0);
                        resolve();
                    }, 500);
                });
            },
            buttons: [
                {
                    classes: 'shepherd-button-primary',
                    text: 'Next',
                    type: 'next',
                },
            ],
            classes: 'mt-16 shepherd-tour',
            title: 'Review your cart',
            text: [
                'Cart auto-generated from labs in the sample prescription. You can edit tests here, But you cannot add tests in this trial order',
            ],
            when: {
                show: () => {
                    changeSteps && changeSteps(1);
                    track('TRIAL_ORDER_CURRENT_STEP', {
                        type: 'lab',
                        step: 'review-cart',
                    });
                },
                hide: () => {
                    console.log('hide step');
                },
                cancel: () => {
                    track('TRIAL_ORDER_CANCEL_BUTTON_CLICKED', {
                        type: 'lab',
                        on: 'review-cart',
                    });
                },
            },
        },
        {
            id: 'apply-discount',
            attachTo: { element: '#apply-discount', on: 'bottom' as PopperPlacement },
            beforeShowPromise: function () {
                return new Promise<void>(function (resolve) {
                    setTimeout(function () {
                        window.scrollTo(0, 0);
                        resolve();
                    }, 500);
                });
            },
            buttons: [
                {
                    classes: 'shepherd-button-primary',
                    text: 'Back',
                    type: 'back',
                },
                {
                    classes: 'shepherd-button-primary',
                    text: 'Next',
                    type: 'next',
                },
            ],
            classes: 'mt-16 shepherd-tour',
            title: 'Add your discount here',
            text: [
                'You can apply any percent of discount up to 40%. For now, add 10% discount and click on “Apply”.',
            ],
            when: {
                show: () => {
                    changeSteps && changeSteps(2);
                    track('TRIAL_ORDER_CURRENT_STEP', {
                        type: 'lab',
                        step: 'apply-discount',
                    });
                },
                hide: () => {
                    console.log('hide step');
                },
                cancel: () => {
                    track('TRIAL_ORDER_CANCEL_BUTTON_CLICKED', {
                        type: 'lab',
                        on: 'apply-discount',
                    });
                },
            },
        },
        {
            id: 'add-address',
            attachTo: { element: '#add-address', on: 'bottom' as PopperPlacement },
            beforeShowPromise: function () {
                return new Promise<void>(function (resolve) {
                    setTimeout(function () {
                        window.scrollTo(0, 0);
                        resolve();
                    }, 500);
                });
            },
            buttons: [
                {
                    classes: 'shepherd-button-primary',
                    text: 'Back',
                    type: 'back',
                },
                {
                    classes: 'shepherd-button-primary',
                    text: 'Next',
                    type: 'next',
                },
            ],
            classes: 'mt-16 shepherd-tour',
            title: 'Add your delivery address here',
            text: ['For this trial, you can add your clinic address here. Click on “Add Address”.'],
            when: {
                show: () => {
                    changeSteps && changeSteps(3);
                    track('TRIAL_ORDER_CURRENT_STEP', {
                        type: 'lab',
                        step: 'add-address',
                    });
                },
                hide: () => {
                    console.log('hide step');
                },
                cancel: () => {
                    track('TRIAL_ORDER_CANCEL_BUTTON_CLICKED', {
                        type: 'lab',
                        on: 'add-address',
                    });
                },
            },
        },
        {
            id: 'select-slot',
            attachTo: { element: '#select-slot', on: 'bottom' as PopperPlacement },
            beforeShowPromise: function () {
                return new Promise<void>(function (resolve) {
                    setTimeout(function () {
                        window.scrollTo(0, 0);
                        resolve();
                    }, 500);
                });
            },
            buttons: [
                {
                    classes: 'shepherd-button-primary',
                    text: 'Back',
                    type: 'back',
                },
                {
                    classes: 'shepherd-button-primary',
                    text: 'Next',
                    type: 'next',
                },
            ],
            classes: '-mt-20 shepherd-tour',
            title: 'Click on “Select slot” to proceed.',
            text: ['Select slot for sample collection. Click on “Select Slot”.'],
            when: {
                show: () => {
                    changeSteps && changeSteps(4);
                    track('TRIAL_ORDER_CURRENT_STEP', {
                        type: 'lab',
                        step: 'select-slot',
                    });
                },
                hide: () => {
                    console.log('hide step');
                },
                cancel: () => {
                    track('TRIAL_ORDER_CANCEL_BUTTON_CLICKED', {
                        type: 'lab',
                        on: 'select-slot',
                    });
                },
            },
        },
        {
            id: 'place-order',
            attachTo: { element: '#place-order', on: 'bottom' as PopperPlacement },
            beforeShowPromise: function () {
                return new Promise<void>(function (resolve) {
                    setTimeout(function () {
                        window.scrollTo(0, 0);
                        resolve();
                    }, 500);
                });
            },
            buttons: [
                {
                    classes: 'shepherd-button-primary',
                    text: 'Back',
                    type: 'back',
                },
            ],
            classes: '-mt-20 shepherd-tour',
            title: 'Click on “Place order” to confirm.',
            text: ['Try it, you won’t be charged for this.'],
            when: {
                show: () => {
                    changeSteps && changeSteps(5);
                    track('TRIAL_ORDER_CURRENT_STEP', {
                        type: 'lab',
                        step: 'place-order',
                    });
                },
                hide: () => {
                    console.log('hide step');
                },
                cancel: () => {
                    track('TRIAL_ORDER_CANCEL_BUTTON_CLICKED', {
                        type: 'lab',
                        on: 'place-order',
                    });
                },
            },
        },
    ];

    return steps;
}

interface Option {
    vendor: string;
    vendor_id: string;
}

export const PreferredLabPartner: React.FC<{
    option: Option;
    preferredLabPartnerId: string[];
    preferredLabPartnerIdHandler: (id: string) => void;
}> = ({ option, preferredLabPartnerId, preferredLabPartnerIdHandler }) => {
    const { vendor, vendor_id } = option;
    return (
        <AntTooltip
            placement="bottom"
            content={`${
                preferredLabPartnerId.includes(vendor_id) ? 'Remove' : 'Mark'
            } ${vendor} as preferred Lab Partner`}
        >
            {preferredLabPartnerId.includes(vendor_id) ? (
                <svg
                    className="w-24 h-24 fill-darwin-accent-bright-yellow-800 cursor-pointer"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    onClick={(e) => {
                        e.stopPropagation();
                        preferredLabPartnerIdHandler(vendor_id);
                    }}
                >
                    <path d="M12.875 4.5625L14.9062 8.71875L19.375 9.375C19.75 9.4375 20.0625 9.6875 20.1875 10.0625C20.3125 10.4062 20.2188 10.8125 19.9375 11.0625L16.6875 14.2812L17.4688 18.8438C17.5312 19.2188 17.375 19.5938 17.0625 19.8125C16.75 20.0625 16.3438 20.0625 16 19.9062L12 17.75L7.96875 19.9062C7.65625 20.0625 7.25 20.0625 6.9375 19.8125C6.625 19.5938 6.46875 19.2188 6.53125 18.8438L7.28125 14.2812L4.03125 11.0625C3.78125 10.8125 3.6875 10.4062 3.78125 10.0625C3.90625 9.6875 4.21875 9.4375 4.59375 9.375L9.09375 8.71875L11.0938 4.5625C11.25 4.21875 11.5938 4 12 4C12.375 4 12.7188 4.21875 12.875 4.5625Z" />
                </svg>
            ) : (
                <svg
                    className="w-24 h-24 fill-darwin-accent-bright-yellow-800 cursor-pointer"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    onClick={(e) => {
                        e.stopPropagation();
                        preferredLabPartnerIdHandler(vendor_id);
                    }}
                >
                    <path d="M11.9688 4C12.2812 4 12.5312 4.1875 12.6562 4.4375L14.8125 8.84375L19.5938 9.5625C19.875 9.59375 20.0938 9.8125 20.1875 10.0625C20.2812 10.3438 20.2188 10.625 20 10.8438L16.5312 14.2812L17.3438 19.125C17.4062 19.4062 17.2812 19.7188 17.0625 19.875C16.8125 20.0312 16.5 20.0625 16.25 19.9375L11.9688 17.625L7.6875 19.9375C7.4375 20.0625 7.15625 20.0312 6.90625 19.875C6.6875 19.7188 6.5625 19.4062 6.59375 19.125L7.4375 14.2812L3.96875 10.8438C3.75 10.625 3.6875 10.3438 3.78125 10.0625C3.875 9.8125 4.09375 9.59375 4.375 9.5625L9.15625 8.84375L11.3125 4.4375C11.4375 4.1875 11.6875 4 11.9688 4ZM11.9688 6.46875L10.3438 9.875C10.2188 10.0938 10.0312 10.25 9.78125 10.2812L6.0625 10.8125L8.75 13.4688C8.9375 13.6562 9 13.9062 8.96875 14.1562L8.34375 17.875L11.625 16.125C11.8438 16 12.125 16 12.3438 16.125L15.625 17.875L15 14.1562C14.9375 13.9062 15.0312 13.6562 15.2188 13.4688L17.875 10.8125L14.1875 10.2812C13.9375 10.25 13.7188 10.0938 13.625 9.875L11.9688 6.46875Z" />
                </svg>
            )}
        </AntTooltip>
    );
};

const newLogoSet = new Set(['v_007_56']);

export const getVendorLogo = (vendor_id: string = ''): string => {
    const clinicid = getSelectedClinicId() || '';
    const clinics = getDoc()?.profile.professional.clinics;
    const selectedClinic = clinics?.find((i) => i._id === clinicid);
    const pincode = String(selectedClinic?.address?.pin || '').slice(0, 2);
    const vendorId = vendor_id.toLowerCase();
    const imgUrl = `${vendorId}_${pincode}`;
    return `/images/${newLogoSet.has(imgUrl) ? imgUrl : vendorId}.png`;
};

export const inClinicSampleCollectionEnabled = new Set(['v_001', 'v_014']);
export const INCLINIC_COLLECTION = 'inclinic_collection';
export const HOME_COLLECTION = 'home_collection';
export const sampleCollectionTypes = [INCLINIC_COLLECTION, HOME_COLLECTION];

export const getClinicAddress = (): AddressFormInput => {
    const clinicid = getSelectedClinicId() || '';
    const clinics = getDoc()?.profile.professional.clinics;
    const selectedClinic = clinics?.find((i) => i._id === clinicid);
    const { line1, city, state, pin } = (selectedClinic?.address as Address) || {};
    const address = {
        line: line1,
        landmark: '',
        city,
        state,
        city_id: '',
        coordinates: ' ',
        pincode: pin || ' ',
        place_id: '',
    };
    return address;
};

export const labCancellationReasons: { [k: string]: string } = {
    testing: 'This was a test order',
    modify_test: 'Add/remove tests',
    customer_denied: 'Customer denied the order',
    discount_not_applied: 'Discount not applied',
    wrong_discount: 'Applied wrong discount',
    wrong_test_selected: 'Wrong test selected while booking',
    price_issue: 'Price issue in the order',
    others_remarks: 'Others - Remarks',
};

const testingTypeObj: { [k: string]: { color: string; backgroundColor: string } } = {
    specialised: {
        color: '#143999',
        backgroundColor: '#D3DFFF',
    },
    regulated: {
        color: '#8A63D2',
        backgroundColor: '#F6F2FF',
    },
};
const validTestingType = new Set(['specialised', 'regulated']);

export const TestingType: React.FC<{
    i: LabTest;
    className: string;
}> = ({ i, className }) => {
    const testingType = i?.testing_type?.toLowerCase() || '';
    const isValidTestingType = validTestingType.has(testingType);

    return isOnboardedForLab() && testingType && isValidTestingType ? (
        <span
            className={`rounded-4 capitalize font-700 ${className}`}
            style={testingTypeObj[testingType]}
        >
            {testingType}
        </span>
    ) : null;
};

export const AdditionalMembers: React.FC<{
    name: string;
    age: number;
    gender: string;
    mobile: string;
    additionalMembers: AdditionalMemberWithPersonal[];
    toggleAddAdditionalMember: () => void;
    deleteAdditionalMember: (patient_id: string) => void;
    hideAddMemberButton?: boolean;
}> = ({
    name,
    age,
    gender,
    mobile,
    additionalMembers,
    toggleAddAdditionalMember,
    deleteAdditionalMember,
    hideAddMemberButton,
}) => {
    return (
        <div className="space-y-16 p-16 pb-0">
            <div className="flex items-start space-x-8">
                <p>1.</p>
                <div className="flex-1 space-y-2">
                    <div className="w-full flex items-center justify-between">
                        <p>
                            {name} | {age}y | {gender.toUpperCase()[0]}
                        </p>
                        <p className="text-darwin-neutral-900">from Rx</p>
                    </div>
                    <p>+91 {mobile}</p>
                </div>
            </div>
            {additionalMembers.map(({ name, patient_id, personal, mobile }, index) => {
                const ageObj = personal.age || {};
                const age = getAgeInYears(ageObj) || 18;
                const { gender } = personal;
                return (
                    <div className="flex items-start space-x-8">
                        <p>{index + 2}.</p>
                        <div className="flex-1 space-y-2">
                            <div className="w-full flex items-center justify-between">
                                <p>
                                    {name} | {age}y | {gender.toUpperCase()[0]}
                                </p>
                                <p
                                    onClick={() => deleteAdditionalMember(patient_id)}
                                    className="cursor-pointer"
                                >
                                    <svg
                                        className="w-13 h-15 fill-darwin-status-warning-500"
                                        viewBox="0 0 13 15"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M5.21484 2.0625C5.13281 2.0625 5.07812 2.11719 5.02344 2.17188L4.50391 2.9375H8.46875L7.94922 2.17188C7.92188 2.11719 7.83984 2.0625 7.75781 2.0625H5.21484ZM10.0547 2.9375H10.4102H11.75H11.9688C12.3242 2.9375 12.625 3.23828 12.625 3.59375C12.625 3.97656 12.3242 4.25 11.9688 4.25H11.6406L10.9844 13.1367C10.9023 14.0664 10.1641 14.75 9.23438 14.75H3.73828C2.80859 14.75 2.07031 14.0664 1.98828 13.1367L1.33203 4.25H1.03125C0.648438 4.25 0.375 3.97656 0.375 3.59375C0.375 3.23828 0.648438 2.9375 1.03125 2.9375H1.25H2.5625H2.91797L3.92969 1.43359C4.20312 1.02344 4.69531 0.75 5.21484 0.75H7.75781C8.27734 0.75 8.76953 1.02344 9.04297 1.43359L10.0547 2.9375ZM10.3281 4.25H2.64453L3.30078 13.0547C3.32812 13.2734 3.51953 13.4375 3.73828 13.4375H9.23438C9.45312 13.4375 9.64453 13.2734 9.67188 13.0547L10.3281 4.25Z" />
                                    </svg>
                                </p>
                            </div>
                            <p>+91 {mobile}</p>
                        </div>
                    </div>
                );
            })}
            {!hideAddMemberButton && (
                <button
                    className="btn--small primary-btn px-16 py-6 mt-8"
                    onClick={toggleAddAdditionalMember}
                >
                    Add Member
                </button>
            )}
        </div>
    );
};

export const AllVendorsContainer: React.FC<{
    labOptions: LabOption[];
    preferredLabPartnerId: string[];
    preferredLabPartnerIdHandler: (id: string) => void;
}> = ({ labOptions, preferredLabPartnerId, preferredLabPartnerIdHandler }) => {
    const data: {
        vendor: string;
        vendor_id: string;
        mrp: number;
    }[] = [];

    labOptions.forEach(({ vendor, vendor_id, mrp }) => {
        const option = data.find((i) => i.vendor_id === vendor_id);
        if (option) {
            option.mrp = Math.min(mrp, option.mrp);
        } else {
            data.push({
                vendor: vendor,
                vendor_id: vendor_id,
                mrp: mrp,
            });
        }
    });

    return (
        <div className="p-16 flex space-x-8 whitespace-nowrap overflow-scroll bg-white">
            {data.map((i) => (
                <div
                    className="px-12 py-8 border border-neutral-7 hover:border-darwin-primary-500 hover:text-darwin-primary-500 space-y-7 min-w-160 rounded-4 transition-all duration-300 ease-in-out"
                    onClick={() => {
                        focusCard(i.vendor_id);
                        track('BOOK_LAB_TEST_VENDOR_CLICK', {
                            vendor: i.vendor,
                            vendor_id: i.vendor_id,
                        });
                    }}
                >
                    <div className="flex items-center justify-between">
                        <p className="text-18 font-700">₹{i.mrp}</p>
                        <PreferredLabPartner
                            option={{
                                vendor: i.vendor,
                                vendor_id: i.vendor_id,
                            }}
                            preferredLabPartnerId={preferredLabPartnerId}
                            preferredLabPartnerIdHandler={preferredLabPartnerIdHandler}
                        />
                    </div>
                    <img
                        src={getVendorLogo(i.vendor_id)}
                        alt={i.vendor}
                        className="h-24 min-w-56"
                    />
                </div>
            ))}
        </div>
    );
};

export const getPrescription = (
    patient: Patient,
    labTests: LabTestsEntityOrProceduresEntity[],
): Prescription | undefined => {
    try {
        const docProfile = getDoc();

        if (!docProfile) return;

        const { _id } = docProfile;
        const visitId = generateVisitId(_id);
        const prescriptionId = generatePrescriptionId(_id, visitId);
        const clinicId = getSelectedClinicId();
        const clinic = docProfile.profile.professional?.clinics
            ? docProfile?.profile.professional?.clinics.find((i) => i._id === clinicId)
            : docProfile.profile.professional?.clinics?.[0];
        const { id, localId } = patient;
        const ageInMonths = patient && patient.personal.age && getAgeInMonths(patient.personal.age);

        const bePatient = {
            id: id,
            localId: localId,
            profile: patient && {
                personal: {
                    ...patient.personal,
                    name: [patient.personal.name.f, patient.personal.name.l]
                        .filter(Boolean)
                        .join(' '),
                    age: patient.personal.age?.dob
                        ? { dob: moment(patient.personal.age?.dob).format('YYYY-MM-DD') }
                        : ageInMonths
                        ? { ageInMonths: ageInMonths }
                        : undefined,
                },
            },
        };

        return {
            id: prescriptionId,
            date: new Date(),
            visitId: visitId,
            clinic: clinic as Clinic,
            doctor: docProfile,
            patient: bePatient,
            labTests: labTests,
        };
    } catch (err) {
        captureError(err as Error);
        track('ERROR', {
            on: 'getLabTestsPrescriptionForQuickCart',
            error: (err as Error).message,
        });
    }
};

export const calculateExtraCharges = (i: LabOption): number => {
    const extraChargesArray = Object.entries(i?.extra_charges || {});
    const totalExtraCharges = extraChargesArray.reduce((acc, cur) => {
        return acc + cur[1];
    }, 0);
    return totalExtraCharges;
};

export const InfoText: React.FC = () => {
    return (
        <div
            className="px-16 py-8 flex items-center space-x-8 rounded-8 border"
            style={{
                borderColor: '#EDAE0C',
                background: '#FDF7E7',
            }}
        >
            <p>
                <svg className="w-14 h-14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M7 13.625C4.66406 13.625 2.53125 12.4062 1.36328 10.375C0.195312 8.36914 0.195312 5.90625 1.36328 3.875C2.53125 1.86914 4.66406 0.625 7 0.625C9.31055 0.625 11.4434 1.86914 12.6113 3.875C13.7793 5.90625 13.7793 8.36914 12.6113 10.375C11.4434 12.4062 9.31055 13.625 7 13.625ZM7 3.875C6.64453 3.875 6.39062 4.1543 6.39062 4.48438V7.32812C6.39062 7.68359 6.64453 7.9375 7 7.9375C7.33008 7.9375 7.60938 7.68359 7.60938 7.32812V4.48438C7.60938 4.1543 7.33008 3.875 7 3.875ZM6.1875 9.5625C6.1875 10.0195 6.54297 10.375 7 10.375C7.43164 10.375 7.8125 10.0195 7.8125 9.5625C7.8125 9.13086 7.43164 8.75 7 8.75C6.54297 8.75 6.1875 9.13086 6.1875 9.5625Z"
                        fill="#8E6807"
                    />
                </svg>
            </p>
            <p style={{ color: '#1A1A1A' }}>No changes allowed by the lab partner.</p>
        </div>
    );
};

const UPDATE_SLOT = 'update_slot';
const UPDATE_TESTS = 'update_tests';
const UPDATE_PAYMODE = 'update_paymode';
const UPDATE_DISCOUNT = 'update_discount';

const LabOrderEditUpdate: React.FC<{
    visible?: boolean;
    status: string;
    successText: string;
    failureText: string;
    onTryAgain: () => void;
}> = ({ visible, status, successText, failureText, onTryAgain }) => {
    if (!visible) return null;
    const isSuccess = status === 'success';
    return (
        <div
            className="flex items-center space-x-8 px-12 py-8 rounded-4"
            style={!isSuccess ? { background: '#FBEDEC' } : undefined}
        >
            <p>
                {isSuccess ? (
                    <svg
                        className="w-16 h-16"
                        viewBox="0 0 15 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.5 13.625C5.16406 13.625 3.03125 12.4062 1.86328 10.375C0.695312 8.36914 0.695312 5.90625 1.86328 3.875C3.03125 1.86914 5.16406 0.625 7.5 0.625C9.81055 0.625 11.9434 1.86914 13.1113 3.875C14.2793 5.90625 14.2793 8.36914 13.1113 10.375C11.9434 12.4062 9.81055 13.625 7.5 13.625ZM10.3691 5.93164H10.3438C10.5977 5.70312 10.5977 5.32227 10.3438 5.06836C10.1152 4.83984 9.73438 4.83984 9.50586 5.06836L6.6875 7.91211L5.49414 6.71875C5.24023 6.46484 4.85938 6.46484 4.63086 6.71875C4.37695 6.94727 4.37695 7.32812 4.63086 7.55664L6.25586 9.18164C6.48438 9.43555 6.86523 9.43555 7.11914 9.18164L10.3691 5.93164Z"
                            fill="#19A66A"
                        />
                    </svg>
                ) : (
                    <svg
                        className="w-16 h-16"
                        viewBox="0 0 15 14"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M7.5 13.625C5.16406 13.625 3.03125 12.4062 1.86328 10.375C0.695312 8.36914 0.695312 5.90625 1.86328 3.875C3.03125 1.86914 5.16406 0.625 7.5 0.625C9.81055 0.625 11.9434 1.86914 13.1113 3.875C14.2793 5.90625 14.2793 8.36914 13.1113 10.375C11.9434 12.4062 9.81055 13.625 7.5 13.625ZM5.44336 5.06836C5.18945 5.32227 5.18945 5.70312 5.44336 5.93164L6.63672 7.125L5.44336 8.31836C5.18945 8.57227 5.18945 8.95312 5.44336 9.18164C5.67188 9.43555 6.05273 9.43555 6.28125 9.18164L7.47461 7.98828L8.66797 9.18164C8.92188 9.43555 9.30273 9.43555 9.53125 9.18164C9.78516 8.95312 9.78516 8.57227 9.53125 8.31836L8.33789 7.125L9.53125 5.93164C9.78516 5.70312 9.78516 5.32227 9.53125 5.06836C9.30273 4.83984 8.92188 4.83984 8.66797 5.06836L7.47461 6.26172L6.28125 5.06836C6.05273 4.83984 5.67188 4.83984 5.44336 5.06836Z"
                            fill="#D74B41"
                        />
                    </svg>
                )}
            </p>
            <p>{isSuccess ? successText : failureText}</p>
            {!isSuccess && (
                <button
                    className="flex items-center space-x-6 text-darwin-accent-bright-blue-800 font-700 text-13"
                    onClick={onTryAgain}
                >
                    <p>Try again</p>
                    <p>
                        <svg
                            className="w-12 h-12 fill-darwin-accent-bright-blue-800"
                            viewBox="0 0 13 12"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M12.5938 4.70312C12.5938 5.05859 12.3145 5.3125 11.9844 5.3125H9.14062H8.32812C7.97266 5.3125 7.71875 5.05859 7.71875 4.70312C7.71875 4.37305 7.97266 4.09375 8.32812 4.09375H9.14062H10.5117L9.19141 2.77344C8.45508 2.0625 7.49023 1.65625 6.5 1.65625C4.64648 1.65625 3.04688 2.79883 2.38672 4.39844C2.23438 4.70312 1.87891 4.83008 1.57422 4.70312C1.26953 4.57617 1.11719 4.2207 1.24414 3.91602C2.10742 1.88477 4.13867 0.4375 6.5 0.4375C7.82031 0.4375 9.08984 0.970703 10.0293 1.91016L11.375 3.25586V1.85938V1.04688C11.375 0.716797 11.6289 0.4375 11.9844 0.4375C12.3145 0.4375 12.5938 0.716797 12.5938 1.04688V4.70312ZM1.01562 6.9375H3.85938C4.18945 6.9375 4.46875 7.2168 4.46875 7.54688C4.46875 7.90234 4.18945 8.15625 3.85938 8.15625H2.46289L3.80859 9.50195C4.51953 10.2129 5.48438 10.5938 6.5 10.5938C8.32812 10.5938 9.92773 9.50195 10.5879 7.90234C10.7402 7.57227 11.0957 7.44531 11.4004 7.57227C11.7051 7.69922 11.8574 8.05469 11.7305 8.38477C10.8418 10.3906 8.83594 11.8125 6.5 11.8125C5.1543 11.8125 3.88477 11.3047 2.94531 10.3652L1.625 9.01953V10.3906C1.625 10.7461 1.3457 11 1.01562 11C0.660156 11 0.40625 10.7461 0.40625 10.3906V7.54688C0.40625 7.2168 0.660156 6.9375 1.01562 6.9375Z" />
                        </svg>
                    </p>
                </button>
            )}
        </div>
    );
};

export const LabOrderEditUpdates: React.FC<{
    patientName: string;
    closeMe: () => void;
    updateStatuses: UpdateStatuses;
    onTryAgain: () => void;
}> = ({ patientName, closeMe, updateStatuses, onTryAgain }) => {
    const slotUpdate = updateStatuses?.[UPDATE_SLOT];
    const testsUpdate = updateStatuses?.[UPDATE_TESTS];
    const paymodeUpdate = updateStatuses?.[UPDATE_PAYMODE];
    const discountUpdate = updateStatuses?.[UPDATE_DISCOUNT];

    const dataToShow = [
        {
            key: UPDATE_TESTS,
            isVisible: Boolean(testsUpdate),
            status: testsUpdate?.status,
            successText: 'New lab tests booked',
            failureText: 'Lab tests update failed!',
        },
        {
            key: UPDATE_DISCOUNT,
            isVisible: Boolean(discountUpdate),
            status: discountUpdate?.status,
            successText: 'New discount applied',
            failureText: 'Discount update failed!',
        },
        {
            key: UPDATE_PAYMODE,
            isVisible: Boolean(paymodeUpdate),
            status: paymodeUpdate?.status,
            successText: 'Payment mode changed',
            failureText: 'Payment mode update failed!',
        },
        {
            key: UPDATE_SLOT,
            isVisible: Boolean(slotUpdate),
            status: slotUpdate?.status,
            successText: 'Slot rescheduled',
            failureText: 'Slot reschedule failed!',
        },
    ];

    return (
        <Modal
            bodyStyle={{
                padding: '0px',
                borderRadius: '8px !important',
                height: '360px',
            }}
            visible={true}
            width={400}
            onCancel={(e) => {
                e.stopPropagation();
                closeMe();
            }}
            footer={null}
            closable={false}
            destroyOnClose
            style={{ borderRadius: '8px !important', height: '360px' }}
            className="overflow-hidden rounded-8"
        >
            <div
                className="p-24 h-full overflow-hidden flex flex-col"
                onClick={(e) => e.stopPropagation()}
                style={{ color: '#1A1A1A' }}
            >
                <p className="text-20 text-center">
                    Following edits have been made to your lab order for {patientName}
                </p>
                <div className="flex-1 overflow-auto w-max mx-auto mt-16 mb-20 space-y-6">
                    {dataToShow.map(({ isVisible, status, successText, failureText }) => (
                        <LabOrderEditUpdate
                            visible={isVisible}
                            status={status}
                            successText={successText}
                            failureText={failureText}
                            onTryAgain={onTryAgain}
                        />
                    ))}
                </div>
                <div className="flex items-center justify-center">
                    <button
                        className="text-16 font-700 px-11 py-9 border border-darwin-accent-bright-blue-800 bg-darwin-accent-bright-blue-800 text-white rounded-8"
                        onClick={closeMe}
                    >
                        Got it
                    </button>
                </div>
            </div>
        </Modal>
    );
};
